"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NSFW_CLASSES = {
    0: 'Drawing',
    1: 'Hentai',
    2: 'Neutral',
    3: 'Porn',
    4: 'Sexy'
};
//# sourceMappingURL=nsfw_classes.js.map